//TODO cleanup imports
import TimeSince from '../components/screens/TimeSince';
import Start from '../components/screens/Start';
import GenderSelect from '../components/screens/GenderSelect';
import Male from '../components/screens/Male';
import Female from '../components/screens/Female';
import Over72Hours from '../components/screens/Over72Hours';
import Ella from '../components/screens/Ella';
import Clinics from '../components/screens/Clinics';
import BirthControl from '../components/screens/BirthControl';
import PharmacyListing from '../components/screens/PharmacyListing';
import PregnancyTestList from '../components/screens/PregnancyTestList';
import Kaiser from '../components/screens/Kaiser';
import Novato from '../components/screens/Novato';
import NovatoInfo from '../components/screens/NovatoInfo';
import Huckleberry from '../components/screens/Huckleberry';
import Fpact from '../components/screens/Fpact';
import HasFpact from '../components/screens/HasFpact';
import NoFpact from '../components/screens/NoFpact';
import FpactList from '../components/screens/FpactList';
import LocationPage from '../components/screens/LocationPage';

const routes = [
    {
        path: '/over72hours',
        component: Over72Hours
    },
    {
        path: '/timesince',
        component: TimeSince
    },
    {
        path: '/gender',
        component: GenderSelect
    },
    {
        path: '/ella',
        component: Ella
    }, 
    {
        path: '/clinics',
        component: Clinics
    }, 
    {
        path: '/birthcontrol',
        component: BirthControl
    }, 
    {
        path: '/pharmacylist',
        component: PharmacyListing
    },
    {
        path: '/pregnancytest',
        component: PregnancyTestList
    },
    {
        path: '/male',
        component: Male
    },
    {
        path: '/female',
        component: Female
    },
    {
        path: '/kaiser',
        component: Kaiser
    }, 
    {
        path: '/novato',
        component: Novato
    }, 
    {
        path: '/novatoinfo',
        component: NovatoInfo
    }, 
    {
        path: '/huckleberry',
        component: Huckleberry
    },
    {
        path: '/location',
        component: LocationPage
    }, 
    {
        path: '/fpact',
        component: Fpact
    }, 
    {
        path: '/hasfpact',
        component: HasFpact
    }, 
    {
        path: '/nofpact',
        component: NoFpact
    }, 
    {
        path: '/fpactlist',
        component: FpactList
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/config/routes.js